import { useCallback, useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
  COMMON_MIXPANEL_PROPERTIES,
  PATHWAYS_EVENTS,
  PATHWAYS_PAGE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { useLyraIntl } from '@lyrahealth-inc/shared-app-logic/src/features/intl/hooks/useLyraIntl'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'

import { getDeviceUUID } from '../../data/appGlobals/appGlobalsSelectors'
import { getCustomerName } from '../../data/customer/customerSelectors'
import { trackEventWithObj } from '../../data/mixpanel'
import { useAppDispatch } from '../../data/storeConfiguration/store'
import { doPageLoad } from '../../features/microsite/data/micrositeActions'
import { LYRA_MARKETING_LAUNCH_DAY_REMINDER_LINK } from '../constants/appConstants'

export const useComingSoon = () => {
  const customerName = useSelector(getCustomerName)
  const { activeLanguage } = useLyraIntl()
  const deviceUUID = useSelector(getDeviceUUID)
  const dispatch = useAppDispatch()
  const { productType } = useContext(ProductTypeContext)

  useEffect(() => {
    if (customerName) {
      dispatch(
        doPageLoad(
          customerName,
          {
            [COMMON_MIXPANEL_PROPERTIES.LD_DEVICE_UUID]: deviceUUID,
            ...(customerName !== 'care' && {
              [COMMON_MIXPANEL_PROPERTIES.CUSTOMER_NAME]: customerName,
            }),
          },
          PATHWAYS_PAGE.COMING_SOON,
        ),
      )
    }
  }, [customerName, deviceUUID, dispatch])

  const onNotifyMeOnLaunchPress = useCallback(() => {
    dispatch(
      trackEventWithObj({
        [COMMON_MIXPANEL_PROPERTIES.LD_DEVICE_UUID]: deviceUUID,
        event: PATHWAYS_EVENTS.CLICK_NOTIFY_ME_ON_LAUNCH,
        page: PATHWAYS_PAGE.COMING_SOON,
      }),
    )
    window.location.href = `${LYRA_MARKETING_LAUNCH_DAY_REMINDER_LINK}?customer=${customerName}&lang=${activeLanguage}&productType=${productType}`
  }, [activeLanguage, customerName, deviceUUID, dispatch, productType])

  return {
    onNotifyMeOnLaunchPress,
  }
}
